/*
 * Created Date: Thu, 18th Feb 2021, 17:00:09 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2021 The Distance
 */

import list from './list';
import edit from './edit';
import create from './create';
import { isSuperAdmin } from 'utils';

export default (permissions) => {
  // Super Admins only
  const isVisible = isSuperAdmin(permissions);

  return {
    name: 'admin',
    list: isVisible ? list : null,
    edit: isVisible ? edit : null,
    create: isVisible ? create : null,
    icon: 'user',
    options: {
      menuIndex: 5,
      isHidden: !isVisible,
    },
  };
};
